import React, { useState } from 'react';
import Logo from '../../../assets/dashboard/logo.png';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { addTrainerByAdmin } from '../../../services/Admin/admin';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const AddTrainerForm = ({ onSubmit, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const initialValues = {
    name: '',
    email: '',
    registrationDate: '',
    tempororyPassword: '',
    branch: '',
  };

  const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    registrationDate: Yup.date().required('Registration Date is required'),
    tempororyPassword: Yup.string().required('Temporary Password is required'),
    branch: Yup.string().required('Branch Name is required'),
  });

  const handleSubmit = async (values) => {
    console.log("Form Submitted with values: ", values);
    setLoading(true);
    // Submit logic here (API call etc.)
    // await onSubmit(values);
    try {
      const result = await addTrainerByAdmin(values); // You'll need to create updateCourse function
      // console.log('Trainer Add', result);
      if (result?.success) { 
        setLoading(false)
        toast.success(result?.message);
        navigate(-1);
      }
      else {
        setLoading(false)
        toast.error(result?.message);
      }
    } catch (err) {
      console.error('Failed to process course:', err);
    } finally {
      setLoading(false);
    }
    // setLoading(false);
  };

  return (
    <div className='row justify-content-center my-5'>
      <div className="card shadow col-lg-6">
        <div className="d-flex align-items-center justify-content-center mt-4">
          <div className="text-center mb-4">
            <img src={Logo} alt="Logo" width={100} />
          </div>
        </div>
        <h2 className="text-center fs-4 fw-bold mb-4 text-color">Add Manager</h2>

        <div className="card-body">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ setFieldValue }) => (
              <Form className="mb-4 px-4">
                <div className="form-wrapper">

                  <div className="form-group mb-4">
                    <Field
                      name="name"
                      type="text"
                      placeholder="Name"
                      className="custom-input"
                    />
                    <ErrorMessage name="name" component="div" className="error-text" />
                  </div>

                  <div className="form-group mb-4">
                    <Field
                      name="email"
                      type="email"
                      placeholder="Email"
                      className="custom-input"
                    />
                    <ErrorMessage name="email" component="div" className="error-text" />
                  </div>

                  <div className="form-group mb-4">
                    <Field
                      name="registrationDate"
                      type="date"
                      className="custom-input"
                    />
                    <ErrorMessage name="registrationDate" component="div" className="error-text" />
                  </div>

                  <div className="form-group mb-4">
                    <Field
                      name="tempororyPassword"
                      type="text"
                      placeholder="Temporary Password"
                      className="custom-input"
                    />
                    <ErrorMessage name="tempororyPassword" component="div" className="error-text" />
                  </div>

                  <div className="form-group mb-4">
                    <Field as="select" name="branch" className="custom-input">
                      <option value="">Select Branch</option>
                      <option value="alphington">Alphington</option>
                      <option value="ringwood">Ringwood</option>
                      <option value="ringwood/alphington">Ringwood/Alphington</option>
                    </Field>
                    <ErrorMessage name="branch" component="div" className="error-text" />
                  </div>

                </div>

                <div className="mt-4">
                  <button
                    type="submit"
                    className="text-white w-100 py-2 submit-btn"
                    disabled={loading}
                  >
                    {loading ? 'Loading.....' : 'Confirm'}
                  </button>
                </div>

                {onCancel && (
                  <div className="mt-2">
                    <button
                      type="button"
                      className="btn btn-outline-secondary w-100 py-2"
                      onClick={onCancel}
                      disabled={loading}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default AddTrainerForm;
